import React from 'react';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiPhone, FiMail, FiMessageCircle } = FiIcons;

const CTA = () => {
  const bgImage = "https://img.gedhemedia.com/CTASection_GedheMediaCo.jpeg";

  return (
    <section className="py-32 relative overflow-hidden bg-cover bg-center bg-no-repeat" style={{ backgroundImage: `url(${bgImage})` }} >
      <div className="absolute inset-0 cta-mask z-0"></div>
      
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        <div className="text-center bg-[#0A192F]/40 backdrop-blur-xl border border-white/10 p-10 md:p-20 rounded-[3rem] md:rounded-[5rem] shadow-2xl">
          <h2 className="text-4xl lg:text-7xl font-black text-white mb-8 leading-tight">
            Siap Membuat Digital Anda <br className="hidden md:block" />
            <span className="text-[#FF6B00]">Bekerja untuk Bisnis?</span>
          </h2>
          
          <p className="text-xl md:text-2xl text-gray-100 mb-12 max-w-3xl mx-auto font-bold leading-relaxed">
            Jangan buang waktu dan budget untuk strategi yang tidak terarah. <br />
            Bangun sistem digital yang benar sejak awal bersama GedheMedia.
          </p>

          <div className="flex flex-col items-center space-y-8">
            <div className="flex flex-col sm:flex-row gap-6 justify-center items-center w-full">
              <a 
                href="https://wa.me/6283128418389" 
                target="_blank" 
                rel="noopener noreferrer" 
                className="btn-primary inline-flex items-center px-10 py-5 text-white font-black rounded-2xl text-xl transition-all hover:scale-105 shadow-orange-500/20 shadow-2xl w-full sm:w-auto"
              >
                <SafeIcon icon={FiMessageCircle} className="mr-3 text-2xl" />
                Konsultasi Gratis Sekarang
              </a>
              <a 
                href="mailto:hello@gedhemedia.com" 
                className="btn-secondary inline-flex items-center px-10 py-5 font-black rounded-2xl text-xl transition-all hover:scale-105 backdrop-blur-lg w-full sm:w-auto"
              >
                <SafeIcon icon={FiMail} className="mr-3 text-2xl" />
                Email Inquiry
              </a>
            </div>
            
            <div className="flex flex-wrap justify-center gap-6 md:gap-12 pt-8 border-t border-white/10 w-full">
               <div className="flex items-center text-gray-300 font-bold uppercase tracking-widest text-xs md:text-sm">
                 <span className="w-2 h-2 bg-green-500 rounded-full mr-3 animate-pulse"></span>
                 Tanpa Komitmen
               </div>
               <div className="flex items-center text-gray-300 font-bold uppercase tracking-widest text-xs md:text-sm">
                 <span className="w-2 h-2 bg-green-500 rounded-full mr-3 animate-pulse"></span>
                 Tanpa Hard Selling
               </div>
               <div className="flex items-center text-gray-300 font-bold uppercase tracking-widest text-xs md:text-sm">
                 <span className="w-2 h-2 bg-green-500 rounded-full mr-3 animate-pulse"></span>
                 Fokus Solusi
               </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CTA;